import React, { PureComponent } from "react";
import Dashboard from "./Containers/TeamDashboardContainer";

class TeamDashboard extends PureComponent {
  render() {
    return (
      <div>
        <Dashboard
          team_id={this.props.match.params.id}
          searchParams={this.props.location.search}
        />
      </div>
    );
  }
}

export default TeamDashboard;
